import { Pipe, PipeTransform } from '@angular/core';
import {WP_REST_API_Attachment, WP_REST_API_Post} from "wp-types";
import {WordpressService} from "../../services/wordpress.service";
import {PageExtended} from "../../models/Page/PageExtended";
@Pipe({
  name: 'tinyPostFromId',
  standalone: true
})
export class TinyPostFromIdPipe implements PipeTransform {
  constructor(public wp : WordpressService) {
  }
  transform(id: number): Promise<PageExtended | null> {
    return new Promise<PageExtended | null>((resolve,reject)=>{
      this.wp.getTinyPosts([id]).then((posts)=>{
        if(posts.length){
          resolve(posts[0]);
        }
        resolve(null);
      })
    })
  }
}

@Pipe({
  name: 'tinyPostsFromIds',
  standalone: true
})
export class TinyPostsFromIdsPipe implements PipeTransform {
  constructor(public wp : WordpressService) {
  }
  transform(ids: number[],order:string  = "menu_order"): Promise<PageExtended[]> {
    return this.wp.getTinyPosts(ids,order);
  }
}
